import PropTypes from 'prop-types'
import { TableHead, TableHeader, TableRow } from '@/components/ui/table'

export const TransactionTableHeader = ({ transactionType, page }) => (
  <TableHeader>
    <TableRow>
      <TableHead
        className={`${page === 'home' ? 'md:w-[175px]' : 'md:w-[200px]'} text-dGray-600 font-medium text-xs text-left hidden md:table-cell`}
      >
        Date
      </TableHead>
      <TableHead
        className={`${page === 'home' ? 'md:w-[145px]' : 'md:w-[150px]'} text-dGray-600 font-medium text-xs hidden text-left md:table-cell`}
      >
        Status
      </TableHead>
      <TableHead
        className={`${page === 'home' ? 'md:w-[130px]' : 'md:w-[500px] w-[200px]'} text-dGray-600 font-medium text-left text-xs`}
      >
        Description
      </TableHead>

      <TableHead
        className={`${page === 'home' ? 'md:w-[136px]' : 'md:w-[150px]'} text-dGray-600 font-medium text-xs hidden text-left md:table-cell`}
      >
        {transactionType === 'posted' ? 'Category' : null}
      </TableHead>
      <TableHead
        className={`w-[127px] text-dGray-600 font-medium text-xs text-right md:text-left ${page === 'home' ? 'md:w-[136px]' : 'md:w-[150px]'}`}
      >
        Amount
      </TableHead>
    </TableRow>
  </TableHeader>
)

TransactionTableHeader.propTypes = {
  transactionType: PropTypes.string,
  page: PropTypes.string,
}
